module.exports = __webpack_public_path__ + "media/images/press_kit/azamara/email/top-cc95f074c0efdc941a371bfeffb98c21.png";